import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/layout";
import Home from "./pages/home";

// Home loads eagerly (first paint); every other page is code-split.
const About = lazy(() => import("./pages/about"));
const Services = lazy(() => import("./pages/services"));
const ServiceDetail = lazy(() => import("./pages/service-detail"));
const Industries = lazy(() => import("./pages/industries"));
const IndustryDetail = lazy(() => import("./pages/industry-detail"));
const Work = lazy(() => import("./pages/work"));
const CaseStudy = lazy(() => import("./pages/case-study"));
const Process = lazy(() => import("./pages/process"));
const Pricing = lazy(() => import("./pages/pricing"));
const Resources = lazy(() => import("./pages/resources"));
const BlogPost = lazy(() => import("./pages/blog-post"));
const Contact = lazy(() => import("./pages/contact"));
const FAQ = lazy(() => import("./pages/faq"));
const Privacy = lazy(() => import("./pages/legal").then((m) => ({ default: m.Privacy })));
const Terms = lazy(() => import("./pages/legal").then((m) => ({ default: m.Terms })));
const NotFound = lazy(() => import("./pages/not-found"));

export default function App() {
  return (
    <Suspense fallback={<div style={{ minHeight: "70vh" }} />}>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/industries/:slug" element={<IndustryDetail />} />
          <Route path="/work" element={<Work />} />
          <Route path="/work/:slug" element={<CaseStudy />} />
          <Route path="/process" element={<Process />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
